import React, { useEffect, useState } from "react";
import { CategoryImageicon } from "../../../assets/images";
import { Card, CardBody } from "reactstrap";
import { API_URL, baseUrl } from "../../../services/apiConfig";
import axiosInstance from "../../../services/axios.instance";
import { useQuery } from "react-query";

interface DailyOrderData {
  date: string;
  customer_ids: string[];
  total_order_value: number;
  average_order_value_per_date: number;
}

interface ProfileData {
  total_referred_customers: number;
  conversion_percentage: number;
  average_order_value: number;
  daily_order_data: DailyOrderData[];
}

const PremiumProfile = () => {
  const [profileData, setProfileData] = useState<ProfileData>({
    total_referred_customers: 0,
    conversion_percentage: 0,
    average_order_value: 0,
    daily_order_data: [],
  });
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filteredData, setFilteredData] = useState<DailyOrderData[]>([]);

  const getAccountInfo = useQuery({
    queryKey: "accountInfo",
    queryFn: async () => {
      try {
        const response = await axiosInstance.get(
          `${baseUrl}${API_URL.PREMIUM_PROFILE}`
        );
        setProfileData(response.data);
        setFilteredData(response.data.daily_order_data);
      } catch (error) {
        console.error("Error:", error);
      }
    },
  });
 

  const handleDateFilter = () => {
    if (fromDate && toDate) {
      const filtered = profileData.daily_order_data.filter((order) => {
        const orderDate = new Date(order.date);
        const from = new Date(fromDate);
        const to = new Date(toDate);
        return orderDate >= from && orderDate <= to;
      });
      setFilteredData(filtered);
    } else {
      setFilteredData(profileData.daily_order_data);
    }
  };

  const resetFilter = () => {
    setFromDate("");
    setToDate("");
    setFilteredData(profileData.daily_order_data);
  };

  return (
    <div className="col-md-12 pt-5">
      <Card className="shadow-sm">
        <CardBody>
          <div className="sub-div-headings d-flex pt-3 mb-4">
            <img src={CategoryImageicon} alt="CategoryImageicon" className="me-2" />
            <span className="h4 mb-0">Partner Profile Statistics</span>
          </div>
  
          <div className="row g-4">
            {/* Stats Cards */}
            <div className="col-12 col-md-4">
              <Card className="h-100 border-0 bg-light">
                <CardBody className="text-center">
                  <h5 className="text-dark mb-3">Total Referred Customers</h5>
                  <h2 className="mb-0">{profileData?.total_referred_customers || 0}</h2>
                </CardBody>
              </Card>
            </div>
            <div className="col-12 col-md-4">
              <Card className="h-100 border-0 bg-light">
                <CardBody className="text-center">
                  <h5 className="text-dark mb-3">Conversion Percentage</h5>
                  <h2 className="mb-0">{(profileData?.conversion_percentage || 0).toFixed(2)}%</h2>
                </CardBody>
              </Card>
            </div>
            <div className="col-12 col-md-4">
              <Card className="h-100 border-0 bg-light">
                <CardBody className="text-center">
                  <h5 className="text-dark mb-3">Average Order Value</h5>
                  <h2 className="mb-0">₹{(profileData?.average_order_value || 0).toFixed(2)}</h2>
                </CardBody>
              </Card>
            </div>
  
            {/* Daily Order History Section */}
            <div className="col-12 mt-4">
              <Card className="border-0 shadow-sm">
                <CardBody>
                  <h5 className="text-dark mb-4">Daily Order History</h5>
                  
                  {/* Date Filter Section */}
                  <div className="row g-3 mb-4">
                    <div className="col-12 col-md-4">
                      <label className="form-label">From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                      />
                    </div>
                    <div className="col-12 col-md-4">
                      <label className="form-label">To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                      />
                    </div>
                    <div className="col-12 col-md-4 d-flex align-items-end">
                      <button 
                        className="btn edit-profile-btn me-2" 
                        onClick={handleDateFilter}
                      >
                       Search
                      </button>
                      <button 
                        className="btn btn-outline-secondary" 
                        onClick={resetFilter}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
  
                  {/* Table Section */}
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead className="table-light">
                        <tr>
                          <th>Date</th>
                          <th>Customer Id</th>
                          <th>Total Order Value</th>
                          <th>Average Order Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData?.map((order, index) => (
                          <tr key={index}>
                            <td>{order?.date || '-'}</td>
                            <td>{order?.customer_ids?.[0] || ''}</td>
                            <td>₹{(order?.total_order_value || 0).toFixed(2)}</td>
                            <td>₹{(order?.average_order_value_per_date || 0).toFixed(2)}</td>
                          </tr>
                        ))}
                        {(!filteredData || filteredData.length === 0) && (
                          <tr>
                            <td colSpan={3} className="text-center py-4">
                              No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
  
};

export default PremiumProfile;
